import styled from "styled-components";
interface IProps {
    imageUrl: string;
    grayScale?: boolean;
    backgroundSize?: string;
}
export const CouponImage = ({ imageUrl, grayScale, backgroundSize }: IProps) => {
    return (
        <StyledImage
            url={imageUrl}
            grayScale={grayScale}
            backgroundSize={backgroundSize}
        ></StyledImage>
    );
};
const StyledImage = styled.div<{ url: string; grayScale?: boolean; backgroundSize?: string }>`
    background-image: url(${(p) => p.url});
    filter: ${(p) => (p.grayScale ? "grayscale(100%)" : "")};
    width: 100%;
    height: 100%;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    background-size: ${(p) => p.backgroundSize || "cover"};
    background-repeat: ${(p) => (p.backgroundSize ? "no-repeat" : "")};
    background-position: ${(p) => (p.backgroundSize ? "center" : "")};
`;
